import React, { useEffect, useState } from 'react'
import { withRouter } from 'react-router'
import WidgetsTeacherSignUpForm from './form'
import {logAnalytics, EVENT_TYPES} from 'logAnalytics'


function WidgetsTeacherSignUp(props) {
    const [mounted, setMounted] = useState(false)

    useEffect(() => {
        document.title = 'Math Makers Teacher Sign Up'

        logAnalytics(EVENT_TYPES.PAGE_VIEW, {page: document.title})

        setMounted(true)
    }, [])

    if (!mounted)
        return <></>

    return (
        <>
            <div className='hero-bg'>
                <div className='form-container'>
                    <WidgetsTeacherSignUpForm />
                </div>
            </div>
        </>
    )
}

export default withRouter(WidgetsTeacherSignUp)